const MyList = ({addMeal, mealPlans, deleteDay, selectedDay, setSelectedDay}) => {
    return (
        <div className="whole-plan">
            <div className="list-header">
                <h1>Weekly Meal Ideas</h1>
                <button className="button-add" onClick={addMeal}>Add New Day</button>
            </div>
            
            {/* Этот контейнер будет отвечать за скролл внутри списка */}
            <div className="list-container">
                {mealPlans.map(({id, title, mealForDay}) => (
                    <div 
                        key={id} 
                        className={`meal-item ${id === selectedDay ? "selected" : "default"}`}
                        onClick={() => setSelectedDay(id)}
                    >
                        <div className="meal-info">
                            <p className="title">{title}</p>
                            <p className="subtitle">{mealForDay && mealForDay.substring(0, 20)}</p>
                        </div>
                        <button className="button-delete" onClick={(e) => {
                            e.stopPropagation();
                            deleteDay(id);
                        }}>Delete</button>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default MyList;